"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledPriorityCell = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledPriorityCell = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: 8px;

  .priority-flag-icon {
    font-size: 20px;
  }

  .priority-label {
    white-space: nowrap;
  }
`;
